// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { ComponentWrapper } from '@trello/component-wrapper';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { isPinnedListRoute } from '@trello/routes';

import { ModelCache } from 'app/scripts/db/ModelCache';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { MemberOnCardTemplate } from 'app/scripts/views/templates/MemberOnCardTemplate';
import {
  LazyCardProfileCard,
  LazyProfileCard,
} from 'app/src/components/ProfileCard';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeMemberFromCardFunction = (card: any, member: any) => {
  const source = 'cardMemberMenuInlineDialog';
  const traceId = Analytics.startTask({
    taskName: 'edit-card/idMembers',
    source,
  });

  card.removeMemberWithTracing(
    member.id,
    traceId,
    tracingCallback(
      {
        taskName: 'edit-card/idMembers',
        traceId,
        source,
      },
      () => {
        Analytics.sendUpdatedCardFieldEvent({
          field: 'idMembers',
          source,
          containers: {
            card: { id: card.id },
            board: { id: card.get('idBoard') },
            list: { id: card.get('idList') },
          },
          attributes: {
            taskId: traceId,
            changeType: 'remove member',
          },
        });
      },
    ),
  );
};

const CardViewHelpers = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnCardMenu(e: any) {
    stopPropagationAndPreventDefault(e);

    if (isPinnedListRoute()) {
      return;
    }

    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ openMembe... Remove this comment to see the full error message
    const elem = $(e.target, this.$el).closest('.member');
    const idMem = elem.attr('data-idmem');
    const member = ModelCache.get('Member', idMem);
    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ openMem... Remove this comment to see the full error message
    const card = this.model;

    PopOver.toggle({
      elem,
      reactElement: (
        <ComponentWrapper>
          <LazyCardProfileCard
            key="profile"
            // eslint-disable-next-line react/jsx-no-bind
            onClose={() => PopOver.hide()}
            // @ts-expect-error
            memberId={member.id}
            cardId={card.id}
            // eslint-disable-next-line react/jsx-no-bind
            removeMemberFromCardOverride={() =>
              removeMemberFromCardFunction(card, member)
            }
          />
        </ComponentWrapper>
      ),
      hideHeader: true,
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemberOnAtMention(e: any) {
    stopPropagationAndPreventDefault(e);
    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ openMem... Remove this comment to see the full error message
    const board = this.model.getBoard();
    // Get member from DOM
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ openMembe... Remove this comment to see the full error message
    const elem = $(e.target, this.$el).closest('.atMention');
    const idMem = elem?.text()?.substring(1);
    const member = ModelCache.findOne('Member', 'username', idMem);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'mention',
      actionSubjectId: 'memberMention',
      source: 'cardDetailScreen',
      containers: {
        workspace: {
          id: board?.getOrganization()?.id,
        },
        board: {
          id: board?.id,
        },
        card: {
          // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ openMem... Remove this comment to see the full error message
          id: this.model.id,
        },
      },
      attributes: {
        mentionedMemberId: member?.id,
      },
    });

    if (member) {
      PopOver.toggle({
        elem,
        reactElement: (
          <ComponentWrapper>
            <LazyProfileCard
              key="profile"
              // eslint-disable-next-line react/jsx-no-bind
              onClose={() => PopOver.hide()}
              memberId={member.id}
            />
          </ComponentWrapper>
        ),
        hideHeader: true,
      });
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMemberOnCardHtml(member: any) {
    const data = member.toJSON();

    // @ts-expect-error TS(2339): Property 'model' does not exist on type '{ openMem... Remove this comment to see the full error message
    const board = this.model.getBoard();
    data.isVirtual =
      board?.getOrganization()?.isVirtual(member) || board?.isVirtual(member);
    data.isDeactivated = board?.isDeactivated(member);

    return MemberOnCardTemplate(data);
  },
};

export { CardViewHelpers };
